export const toArray = (array) => (Array.isArray(array) ? array : array ? [array] : []);

/**
 * Filter expression to get unique items from array.
 */
export const distinct = (value, index, array) => array.indexOf(value) === index;
